import 'Styles/login.less';

import LoginForm from './LoginForm';
import EmployeeAcceptInviteForm from './EmployeeAcceptInviteForm';
import ReactDOM from 'react-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';

import SpecTheme from 'Styles/spec-theme';

import { EmitAnalyticsEvent } from '../../app/EmitAnalyticsEvent.js';

const start = () => {
  const showLogout = window.location.search == '?logout';
  const isAcceptInvite = window.location.search.startsWith('?invitationCode');

  const data = window.INITIAL_DATA;
  let code = null;
  if (isAcceptInvite) {
    code = window.location.search.split('=')[1];
  }

  ReactDOM.render(
    <MuiThemeProvider theme={SpecTheme}>
      {isAcceptInvite && (
        <EmployeeAcceptInviteForm
          invitation={data.invitation}
          project={data.project}
          org={data.org}
          invitationCode={code}
        />
      )}
      {showLogout && <div className='banner'>You have been logged out.</div>}
      {!showLogout && <EmitAnalyticsEvent event='Login Page Viewed' />}
      {!isAcceptInvite && <LoginForm showLogout={showLogout} />}
    </MuiThemeProvider>,
    document.getElementById('app'),
  );
};

export default start;
